// extracted by mini-css-extract-plugin
export default {"container":"ADASef","mobile":"jPWd1b"};